import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import "core-js/modules/esnext.global-this.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { ALPHA_MODES } from '@pixi/constants';
import { settings } from '@pixi/settings';
import { BaseImageResource } from './BaseImageResource.mjs';
var ImageBitmapResource = /*#__PURE__*/function (_BaseImageResource) {
  _inherits(ImageBitmapResource, _BaseImageResource);
  var _super = _createSuper(ImageBitmapResource);
  function ImageBitmapResource(source, options) {
    var _this2 = this,
      _options$crossOrigin;
    var _this;
    _classCallCheck(this, ImageBitmapResource);
    var __super = function __super() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [_this2].concat(args));
    };
    options = options || {};
    if (typeof source === "string") {
      __super(ImageBitmapResource.EMPTY);
      _this.url = source;
    } else {
      __super(source);
      _this.url = null;
    }
    _this.crossOrigin = (_options$crossOrigin = options.crossOrigin) !== null && _options$crossOrigin !== void 0 ? _options$crossOrigin : true;
    _this.alphaMode = typeof options.alphaMode === "number" ? options.alphaMode : null;
    _this._load = null;
    if (options.autoLoad !== false) {
      _this.load();
    }
    return _possibleConstructorReturn(_this);
  }
  _createClass(ImageBitmapResource, [{
    key: "load",
    value: function load() {
      var _this3 = this;
      if (this._load) {
        return this._load;
      }
      this._load = new Promise( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve, reject) {
          var response, imageBlob, imageBitmap;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (!(_this3.url === null)) {
                  _context.next = 3;
                  break;
                }
                resolve(_this3);
                return _context.abrupt("return");
              case 3:
                _context.prev = 3;
                _context.next = 6;
                return settings.ADAPTER.fetch(_this3.url, {
                  mode: _this3.crossOrigin ? "cors" : "no-cors"
                });
              case 6:
                response = _context.sent;
                if (!_this3.destroyed) {
                  _context.next = 9;
                  break;
                }
                return _context.abrupt("return");
              case 9:
                _context.next = 11;
                return response.blob();
              case 11:
                imageBlob = _context.sent;
                if (!_this3.destroyed) {
                  _context.next = 14;
                  break;
                }
                return _context.abrupt("return");
              case 14:
                _context.next = 16;
                return createImageBitmap(imageBlob, {
                  premultiplyAlpha: _this3.alphaMode === null || _this3.alphaMode === ALPHA_MODES.UNPACK ? "premultiply" : "none"
                });
              case 16:
                imageBitmap = _context.sent;
                if (!_this3.destroyed) {
                  _context.next = 19;
                  break;
                }
                return _context.abrupt("return");
              case 19:
                _this3.source = imageBitmap;
                _this3.update();
                resolve(_this3);
                _context.next = 30;
                break;
              case 24:
                _context.prev = 24;
                _context.t0 = _context["catch"](3);
                if (!_this3.destroyed) {
                  _context.next = 28;
                  break;
                }
                return _context.abrupt("return");
              case 28:
                reject(_context.t0);
                _this3.onError.emit(_context.t0);
              case 30:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[3, 24]]);
        }));
        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
      return this._load;
    }
  }, {
    key: "upload",
    value: function upload(renderer, baseTexture, glTexture) {
      if (!(this.source instanceof ImageBitmap)) {
        this.load();
        return false;
      }
      if (typeof this.alphaMode === "number") {
        baseTexture.alphaMode = this.alphaMode;
      }
      return _get(_getPrototypeOf(ImageBitmapResource.prototype), "upload", this).call(this, renderer, baseTexture, glTexture);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      if (this.source instanceof ImageBitmap) {
        this.source.close();
      }
      _get(_getPrototypeOf(ImageBitmapResource.prototype), "dispose", this).call(this);
      this._load = null;
    }
  }], [{
    key: "test",
    value: function test(source) {
      return !!globalThis.createImageBitmap && typeof ImageBitmap !== "undefined" && (typeof source === "string" || source instanceof ImageBitmap);
    }
  }, {
    key: "EMPTY",
    get: function get() {
      var _ImageBitmapResource$;
      ImageBitmapResource._EMPTY = (_ImageBitmapResource$ = ImageBitmapResource._EMPTY) !== null && _ImageBitmapResource$ !== void 0 ? _ImageBitmapResource$ : settings.ADAPTER.createCanvas(0, 0);
      return ImageBitmapResource._EMPTY;
    }
  }]);
  return ImageBitmapResource;
}(BaseImageResource);
export { ImageBitmapResource };